export const MAX_CANDIDATE_ALTERNATIVE_PHONE_NUMBERS = 2;
export const MAX_CANDIDATE_FREE_TEXT_LENGTH = 2000;

export const MAX_DISTANCE_MARKS = [
  { value: 0, label: '0min' },
  { value: 30, label: '30min' },
  { value: 60, label: '60min' },
  { value: 90, label: '90min' },
];

export const MAX_DISTANCE_STEP = 5;

export const SALARY_MARKS = [
  { value: 1000, label: '1000€' },
  { value: 2000, label: '2000€' },
  { value: 3000, label: '3000€' },
  { value: 4000, label: '4000€' },
  { value: 5000, label: '5000€' },
  { value: 6000, label: '6000€' },
  { value: 7000, label: '7000€' },
];

export const SALARY_STEP = 100;
